import { axios } from "@LIBS";
import { Constants } from "@CONFIG";

const getAdminUser = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/admin/users/adminUser`,
    method: "GET",
    data: values,
  });

  return response;
};

const createUserWithoutMessage = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/admin/users`,
    method: "POST",
    data: values,
    hideSuccessMessage: true,
    hideErrorMessageFromServer: true,
  });

  return response;
};

export { getAdminUser, createUserWithoutMessage };
